import { InputHTMLAttributes } from 'react'
import { SearchContainer } from './style'
import { ReactComponent as SearchIcon } from '../../assets/icons/search_icon.svg'

interface ISearchBar extends InputHTMLAttributes<HTMLInputElement> {
    className?: string
    noIcon?: boolean
}

export const Search = (props: ISearchBar) => {
    const { className, noIcon, ...rest } = props
    return (
        <SearchContainer className={className}>
            {
                !noIcon ? <SearchIcon /> : <></>
            }
            <input className='input' type='search' {...rest} />
        </SearchContainer>
    )
}
